module.exports = __webpack_public_path__ + "img/fjall1.7cde8447.jpg";